import React from 'react';
import { Container, Typography, Box, Divider, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"League Spartan", sans-serif', // Your local font
    },
});

function Attributions() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    A Crypto Wallet & Gateway to dApps Attributions
                </Typography>
                <Divider />
                
                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Permission
                    </Typography>
                    <Typography paragraph>
                        This permission is granted to anyone who acquires a copy of this software and any accompanying documentation files (collectively referred to as the "Software") to use the Software without any restrictions. This includes the rights to copy, modify, merge, publish, distribute, and sublicense the Software. The following conditions also apply: All copies of the Software or significant portions thereof must include the above copyright notice along with this authorization notice.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Disclaimer
                    </Typography>
                    <Typography paragraph>
                        THE SOFTWARE IS PROVIDED "AS IS" WITHOUT ANY WARRANTIES, EXPRESSED OR IMPLIED. This includes, but is not limited to, the warranties of MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. COPYRIGHT HOLDERS AND AUTHORS SHALL NOT BE LIABLE IN ANY WAY FOR ANY CLAIMS, DAMAGES, OR OTHER LIABILITY ARISING FROM OR RELATED TO THE SOFTWARE, ITS USE, OR OTHER DEALINGS WITH THE SOFTWARE.
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
}

export default Attributions;
